<div class="main-container">
  <form #internalEquipmentListForm="ngForm">

    <div class="toolbar-list">

      <div class="toolbar-list-title">
        <div fxLayout="row" fxLayoutAlign="start center">
          @if (isOnline) {
            <img fxHide.lt-sm src="{{ getThemeIconPath() }}internalEquipments.svg" alt="{{ pageTitle }}">
          }
          <h1 class="accent-color">
          {{ pageTitle }}</h1>
        </div>
        <div class="breadcrumbs">
          <a href="#">{{ 'common.start.label' | translate }}</a> /
          <span>{{ pageTitle }}</span>
        </div>
      </div>

      <div class="toolbar-list-actions">
        @if (canSave()) {
          <button mat-raised-button (click)="new()" color="accent">
            <mat-icon fxHide.lt-sm>add</mat-icon> {{ 'button.new' | translate }}
          </button>
        }

        @if (canSave()) {
          <button mat-raised-button (click)="massiveUpload.click()" color="accent"
            class="stroked">
            <mat-icon fxHide.lt-sm>add</mat-icon> {{ 'button.massive-create' | translate }}
          </button>
        }
        <input accept=".xlsx, .xls, .csv" hidden type="file" (change)="uploadMassive($event)" #massiveUpload>

        @if (canSave()) {
          <button mat-raised-button (click)="massiveCertificateUpload.click()"
            color="accent" class="stroked" [matTooltip]="showToolTipsCertificate()" matTooltipClass="massive-tooltip">
            <mat-icon fxHide.lt-sm>cloud_upload</mat-icon> {{ 'button.massive-upload-cert' | translate }}
          </button>
        }

        <input accept="application/pdf" hidden type="file" multiple (change)="validateMassiveCertificate($event)"
          #massiveCertificateUpload>

        @if (canSave()) {
          <button mat-raised-button (click)="showDialogActionsCertificate()" color="accent" class="stroked"
          >{{ 'button.download-certificates' | translate }}</button>
        }
      </div>
      <div class="toolbar-back-button">
        <a (click)="cancel()" mat-button color="accent">
          <mat-icon color="accent">undo</mat-icon> {{ 'button.back' | translate }}
        </a>
      </div>
    </div>

    <app-internal-equipment-list-filter (filterEmitter)="doFilter($event)" class="filter-container">
    </app-internal-equipment-list-filter>

    <div class="table-container">
      <table #protocols mat-table matSort [dataSource]="dataSourcePerformance" id="table-container">

         <!-- checkbox Column -->
        <ng-container matColumnDef="checkbox">
          <th mat-header-cell *matHeaderCellDef>
            @if (showSelectAll()) {
              <mat-checkbox id="allCheck" name="allCheck" (change)="onCheckAllItems($event)" [(ngModel)]="allSelected">
              </mat-checkbox>
            }
          </th>
          <td mat-cell *matCellDef="let item">
            @if (showCheckbox(item)) {
              <mat-checkbox (change)="onCheckItem($event)" [value]="item"
              [checked]="isSelected(item)"> </mat-checkbox>
            }
          </td>
        </ng-container>
        <!-- name Column -->
        <ng-container matColumnDef="name">
          <th fxShow mat-header-cell *matHeaderCellDef> {{ 'internalEquipmentList.cols.name' | translate }} </th>
          <td fxShow mat-cell *matCellDef="let item" [ngClass]="highlight(item)">
            {{ item.name }}
          </td>
        </ng-container>

        <!-- equipment Column -->
        <ng-container matColumnDef="equipment">
          <th mat-header-cell *matHeaderCellDef> {{ 'internalEquipmentList.cols.equipment' | translate }} </th>
          <td mat-cell *matCellDef="let item" [ngClass]="highlight(item)">
            <div style="white-space: pre-line;"> {{ item.equipment }} </div>
          </td>
        </ng-container>

        <!-- serialNum Column -->
        <ng-container matColumnDef="serialNum">
          <th mat-header-cell *matHeaderCellDef> {{ 'internalEquipmentList.cols.serialNum' | translate }} </th>
          <td mat-cell *matCellDef="let item" [ngClass]="highlight(item)">{{ item.serialNum }} </td>
        </ng-container>

        <!-- certificateNum Column -->
        <ng-container matColumnDef="certificateNum">
          <th mat-header-cell *matHeaderCellDef> {{ 'internalEquipmentList.cols.certificateNum' | translate }} </th>
          <td mat-cell *matCellDef="let item" [ngClass]="highlight(item)" matTooltip="{{ item.documentNum }}"
            matTooltipDisabled="disableTooltip(item)">
            <div>
              @for (doc of item.documentNum; track doc) {
                <a [ngClass]="highlight(item)"
                  mat-button
                  class="link-doc-number table-link-certificate"
                  (click)="downloadPdfActions(doc, item)"
                  matTooltip="{{ 'button.download' | translate }}">
                  <mat-icon>cloud_download</mat-icon>{{ doc ? doc : '--' }}
                </a>
              }
              @if (!item.documentNum || item.documentNum?.length===0) {
                <div>
                  <span>--</span>
                </div>
              }
            </div>
          </td>
        </ng-container>

         <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'internalEquipmentList.cols.client' | translate }}
          </th>
          <td mat-cell *matCellDef="let item" [ngClass]="highlight(item)"> {{ item.clientName | translate }}
          </td>
        </ng-container>

        <!-- status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'internalEquipmentList.cols.status' | translate }}
          </th>
          <td mat-cell *matCellDef="let item"  [ngClass]="highlight(item)">
            <span>{{ 'internalEquipmentStatus.' + item.statusTranslation | translate }}</span>
          </td>
        </ng-container>

        <!-- Next action Column -->
        <ng-container matColumnDef="currentPerformance">
          <th mat-header-cell *matHeaderCellDef  mat-sort-header class="td-center">
            {{ 'internalEquipmentList.cols.idCurrentPerformance' | translate }}
          </th>
          <td mat-cell *matCellDef="let item" [ngClass]="highlight(item)">
            @for (currentAction of item.actionTranslationCurrent; track currentAction) {
              <span>
                <span>{{ currentAction != null ? ('internalEquipmentActions.' + currentAction | translate): '--'}}</span><br/>
              </span>
            }

            @if (!item.actionTranslationCurrent) {
              <span>
                <span>--</span><br/>
              </span>
            }
          </td>
        </ng-container>

        <!-- current date Column -->
        <ng-container matColumnDef="currentDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="td-center">
            {{ 'internalEquipmentList.cols.currentDate' | translate }}
          </th>
          <td mat-cell *matCellDef="let item" [ngClass]="highlight(item)">
            @for (current of item.currentDate; track current) {
              <span>
                <span>{{ current != null ? (current | fixDate) : '--'}}</span><br/>
              </span>
            }

            @if (!item.currentDate || item.currentDate?.length === 0) {
              <span>
                <span>--</span><br/>
              </span>
            }
          </td>
        </ng-container>

        <!-- Next action Column -->
        <ng-container matColumnDef="nextPerformance">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="td-center">
            {{ 'internalEquipmentList.cols.idNextPerformance' | translate }}
          </th>
          <td mat-cell *matCellDef="let item" [ngClass]="highlight(item)">
            @for (actionNext of item.actionTranslationNext; track actionNext) {
              <span>
                <span>{{ actionNext != null ? ('internalEquipmentActions.' + actionNext | translate): '--'}}</span><br/>
              </span>
            }

            @if (!item.actionTranslationNext) {
              <span>
                <span>--</span><br/>
              </span>
            }
          </td>
        </ng-container>

        <!-- Next Date Action Column -->
        <ng-container matColumnDef="dateNextPerformance">
          <th mat-header-cell *matHeaderCellDef  mat-sort-header class="td-center">
          {{ 'internalEquipmentList.cols.dateNextPerformance' | translate }} </th>
          <td mat-cell *matCellDef="let item" [ngClass]="highlight(item)"> {{item.dateNextPerformance ? (item.dateNextPerformance| fixDate) : '--' }} </td>
        </ng-container>

        <!-- action upcoming
        <ng-container matColumnDef="upcomingPerformance">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'internalEquipmentList.cols.idUpcomingPerformance' | translate }}
          </th>
          <td mat-cell *matCellDef="let item" [ngClass]="highlight(item)">
            <span *ngFor="let upcoming of item.actionTranslationUpcoming">
              <span>{{ upcoming != null ? ('internalEquipmentActions.' + upcoming | translate): '--'}}</span> <br/>
            </span>

            <span *ngIf="!item.actionTranslationUpcoming">
              <span>--</span><br/>
            </span>
          </td>
        </ng-container>

        up comming Column
        <ng-container matColumnDef="dateUpcomingPerformance">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'internalEquipmentList.cols.dateUpcomingPerformance' | translate }} </th>
          <td mat-cell *matCellDef="let item" [ngClass]="highlight(item)"> {{item.dateUpcomingPerformance ? (item.dateUpcomingPerformance | fixDateUTC) : '--'}} </td>
        </ng-container>-->

        <!-- Button download Column -->
        <!--<ng-container matColumnDef="download">
        <th mat-header-cell *matHeaderCellDef colspan="3" fxHide.lt-lg>
        {{ 'internalEquipmentList.cols.actions' | translate }} </th>
        <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
          <button mat-icon-button *ngIf="element.idCertificate != null" (click)="downloadPdf(element)"
            matTooltip="{{ 'button.download' | translate }}">
            <mat-icon>cloud_download</mat-icon>
          </button>
        </td>
      </ng-container>-->

      <!-- Button edit Column -->
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"></th>
        <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
          <button mat-icon-button (click)="editRow(element.id)" matTooltip="{{ 'button.edit' | translate }}">
            <mat-icon>mode_edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Button activate Column -->
      <ng-container matColumnDef="activate">
        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"></th>
        <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
          @if (!isDeactivate(element) && canSave()) {
            <button mat-icon-button (click)="deactivate(element)"
              class="active" matTooltip="{{ 'internalEquipmentList.cols.deactivate' | translate }}">
              <mat-icon class="activate">done</mat-icon>
            </button>
          }
          @if (isDeactivate(element) && canSave()) {
            <button mat-icon-button (click)="activate(element)"
              matTooltip="{{ 'internalEquipmentList.cols.activate' | translate }}">
              <mat-icon class="deactivate">clear</mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <!-- Button clone Column -->
      <ng-container matColumnDef="clone">
        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"></th>
        <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
          <button mat-icon-button (click)="cloneRow(element.id)" matTooltip="{{ 'button.clone' | translate }}">
            <mat-icon>folder_copy</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Button more Column -->
      <ng-container matColumnDef="more" stickyEnd>
        <th mat-header-cell *matHeaderCellDef fxHide fxShow.lt-lg></th>
        <td mat-cell *matCellDef="let element" fxHide fxShow.lt-lg class="action">

          <mat-menu #appMenu="matMenu" class="moreActions">
            <ng-template matMenuContent let-name="element">
              @if (element.idCertificate != null) {
                <button mat-button (click)="downloadPdf(element)">
                  <mat-icon>cloud_download</mat-icon> {{ 'button.download' | translate }}
                </button>
              }
              <button mat-button (click)="editRow(element.id)">
                <mat-icon>mode_edit</mat-icon> {{ 'button.edit' | translate }}
              </button>
              @if (!isDeactivate(element) && canSave()) {
                <button mat-button (click)="activate(element)"
                  class="active">
                  <mat-icon class="deactivate">clear</mat-icon> {{ 'internalEquipmentList.cols.activate' | translate }}
                </button>
              }
              @if (isDeactivate(element)  && canSave()) {
                <button mat-button (click)="deactivate(element)">
                  <mat-icon class="activate">done</mat-icon> {{ 'internalEquipmentList.cols.deactivate' | translate }}
                </button>
              }
              <button mat-button (click)="cloneRow(element.id)">
                <mat-icon>folder_copy</mat-icon> {{ 'button.clone' | translate }}
              </button>
            </ng-template>
          </mat-menu>

          <button mat-icon-button [matMenuTriggerFor]="appMenu" [matMenuTriggerData]="element">
            <mat-icon>more_horiz</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    @if (!hasFiltered) {
      <span class="prefilterMessage">
        <p [innerHtml]="'common.listPlaceholder' | translate | safe: 'html'"></p>
      </span>
    }

  </div>

  <div class="table-footer-container">
    <div class="actions">
      <button mat-raised-button (click)="exportTable()" class="stroked-primary">
        <mat-icon fxHide.lt-sm>cloud_download</mat-icon> {{ 'button.xls' | translate }}
      </button>
      @if (isInternal) {
        <button mat-raised-button (click)="showInternalEquipmetUsed()" class="stroked-primary">
          <mat-icon fxHide.lt-sm>open_in_new</mat-icon> {{ 'button.usedEquipment' | translate }}
        </button>
      }
      <button mat-raised-button color="primary" (click)="createPlanAnnualCalibration()" [disabled]="!showCanCalibrationPlanAnnual">
      {{ 'button.calibration-plan-annual' | translate }}</button>
      <a [routerLink]="['.']" [fragment]="'table-container'" class="back-to-top accent-color">
      {{ 'button.backToTop' | translate }} </a>
    </div>
    <div class="paginator">
      <mat-paginator #paginator  [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
        [length]="dataSourcePerformance?.totalItems$ | async" lang="es">
      </mat-paginator>
    </div>
  </div>
</form>
</div>

<ng-template #dialogCertificateActions>
  <h2 mat-dialog-title>{{'internalEquipment.dialog.performance.certificate.title' | translate}}</h2>

  <form>
    <div mat-dialog-content class="calibrates-theme" style="min-height: 10vh;">

      <div fxLayout="column">
        <div fxFlex="100">
          <span> {{ 'internalEquipment.dialog.performance.certificate.label' | translate }}</span>
        </div>
        @for (item of actionsType; track $index) {
          <div fxFlex="100">
            <mat-checkbox [id]="'action'+item.id" [name]="'action'+item.id"
              [(ngModel)]="item.checked">
              {{ showPerformances(item.id) }}
            </mat-checkbox>
          </div>
        }
      </div>
    </div>

    <div mat-dialog-actions class="calibrates-theme">
        <div fxFlex></div>
        <button mat-raised-button color="primary" (click)="onOkClickActionsCertificate()" cdkFocusInitial>{{ 'button.save' | translate
            }}</button>
        <button mat-raised-button color="secondary" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    </div>
  </form>
</ng-template>